/**
 * @flow
 * @format
 */

import { createSelector } from 'reselect';

type Record = any;

const getState = (state: AppStateType) => state.global;

export const getRecordsMap = createSelector(
  [getState],
  state => state.records.data,
);
export const getCurrentRecordId = createSelector(
  [getState],
  state => state.records.current,
);

export const getChartData = createSelector(
  [getState],
  state => state.chartData,
);

export const getDesignName = createSelector(
  [getRecordsMap, getCurrentRecordId],
  (recordMap, currentId) => {
    const record: Record = recordMap.get(currentId);
    let name = '';
    if (record) {
      name =
        record.rev > 1 ? `${record.name} (rev. ${record.rev})` : record.name;
    }

    return record ? name : process.env.REACT_APP_INITIAL_DESIGN_NAME;
  },
);

export default {
  getChartData,
};



// WEBPACK FOOTER //
// ./src/selectors/global.js